import { useLeaveCount } from "../api/queries/leaveQueries";
import usePermissions from "./usePermissions";

/**
 * Who sees the leave review screens (Leave: view):
 * - canReviewLeave: any Leave view (BRANCH scope too; the server scopes the
 *   list, so an empty branch shows an empty list rather than no menu).
 * - companyWide: HR-level leave screens (allocation, replenish, setup).
 * - pendingCount: requests waiting for this user (sidebar badge).
 */
const useLeaveAccess = () => {
  const { can, companyWide } = usePermissions();
  const canView = can("leave");
  const wide = companyWide("leave");
  const pending = useLeaveCount("pending", { enabled: canView });
  return {
    canReviewLeave: canView,
    pendingCount: pending.data ?? 0,
    companyWide: wide,
  };
};

export default useLeaveAccess;
